import apiClient from './apiService';

export type RrKind = 'renewal' | 'review';
export type RrBucket = 'overdue' | 'due' | 'upcoming' | 'completed';

export interface RenewalReviewItem {
    instance_id: number;
    kind: RrKind | null;
    type_code: string | null;
    type_label: string | null;
    icon: string | null;
    title: string | null;
    scheduled_date: string | null;
    status: string | null;
    bucket: RrBucket;
    route_path: string | null;
}

export const renewalsReviewsService = {
    /** Current user's renewal/review cadence obligations, bucketed. */
    async mine(windowDays = 7): Promise<RenewalReviewItem[]> {
        const res = await apiClient.get('/api/v1/sch/renewals-reviews/mine', {
            params: { window_days: windowDays },
        });
        return (res.data?.data ?? []) as RenewalReviewItem[];
    },
};
